import { clsx } from 'clsx';
import { Sparkles, Loader2 } from 'lucide-react';
import type { ButtonHTMLAttributes } from 'react';

interface AiActionButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  onClick: () => void;
  loading?: boolean;
  label: string;
  size?: 'sm' | 'md';
}

export function AiActionButton({
  onClick,
  loading = false,
  label,
  size = 'md',
  className,
  disabled,
  ...props
}: AiActionButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled || loading}
      className={clsx(
        'inline-flex items-center gap-1.5 rounded-lg font-medium transition-all duration-150 active:scale-[0.97]',
        'bg-gradient-to-r from-nexus-600 to-blue-600 text-white',
        'hover:from-nexus-500 hover:to-blue-500',
        'focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-surface-900 focus:ring-nexus-500',
        'disabled:opacity-50 disabled:pointer-events-none cursor-pointer',
        {
          'px-2.5 py-1 text-xs': size === 'sm',
          'px-3.5 py-1.5 text-sm': size === 'md',
        },
        className,
      )}
      {...props}
    >
      {loading ? (
        <Loader2 className={clsx('animate-spin', size === 'sm' ? 'h-3 w-3' : 'h-4 w-4')} />
      ) : (
        <Sparkles className={clsx(size === 'sm' ? 'h-3 w-3' : 'h-4 w-4')} />
      )}
      {label}
    </button>
  );
}
